import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import moment from "moment";
import Booking from "@/components/booking";
import { getBookings } from "@/store/api";

export default {
  components: {
    FullCalendar,
    Booking,
  },

  data() {
    return {
      checkin_date: "",
      checkout_date: "",
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, bootstrapPlugin, listPlugin, timeGridPlugin],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "",
        },
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        selectable: true,
        events: [],
        select: this.handleSelection,
        eventClick: this.onEventClick,
      },
    };
  },

  created() {
    getBookings().then((response) => {
      for (let booking of response) {
        this.setBookings(booking);
      }
    });
  },

  methods: {
    setBookings(booking) {
      for (var reservation of booking.attributes.reservations.data) {
        this.calendarOptions.events.push({
          id: booking.id,
          allDay: true,
          title: `${reservation.attributes.lodging.name} (${booking.attributes.customer.first_name} ${booking.attributes.customer.last_name})`,
          start: reservation.attributes.checkin,
          end: moment(reservation.attributes.checkout).add(1, "day").format("YYYY-MM-DD"),
          backgroundColor: reservation.attributes.lodging.color,
        });
      }
    },

    handleSelection(info) {
      this.$root.$emit("clearBooking");
      this.$bvModal.show("booking-modal");
      this.checkin_date = info.start;
      if (moment(info.end).diff(info.start, "days") === 1) {
        this.checkout_date = info.end;
      } else {
        this.checkout_date = moment(info.end).subtract(1, "days")._d;
      }
    },

    onEventClick(info) {
      this.$router.push(`bookings/${info.event.id}`);
    },
  },
};
